import { EventBus } from '../utils/eventBus';
import { ThemeService, Theme } from '../services/theme';
import { createButton } from '../utils/dom';

export class ThemeToggle {
  private button: HTMLButtonElement | null = null;

  constructor(
    private eventBus: EventBus,
    private themeService: ThemeService
  ) {
    this.setupEventListeners();
  }

  private setupEventListeners(): void {
    this.eventBus.on('theme:changed', (theme: Theme) => {
      this.updateButtonIcon(theme);
    });
  }

  mount(container: HTMLElement): void {
    const currentTheme = this.themeService.getTheme();
    const icon = currentTheme === 'light' ? '🌙' : '☀️';

    this.button = createButton(icon, 'btn btn-theme-toggle', () => {
      this.themeService.toggleTheme();
    });

    this.button.title = 'Toggle theme';
    container.appendChild(this.button);
  }

  private updateButtonIcon(theme: Theme): void {
    if (this.button) {
      this.button.textContent = theme === 'light' ? '🌙' : '☀️';
    }
  }

  destroy(): void {
    this.eventBus.off('theme:changed');
  }
}
